<div class="space-y-3 sm:space-y-4 p-3 sm:p-4">
  <!-- Nombre de producto -->
  <div>
    <label for="nombreProducto" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
      Nombre de Producto
    </label>
    <input
      id="nombreProducto"
      type="text"
      placeholder="Ingrese nombre del producto"
      class="w-full text-sm sm:text-base border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
      [formField]="$any(formData.nombre)"
      autocomplete="product-name"
      [class.border-red-500]="formData.nombre().invalid() && formData.nombre().touched()"
    />
    @if (formData.nombre().invalid() && formData.nombre().touched()) {
      <div class="text-xs text-red-500 mt-1">
        {{ formData.nombre().errors() | formErrorMessage }}
      </div>
    }
  </div>
  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4">
    <!-- Precio -->
    <div class="flex-1">
      <label for="precio" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
        Precio
      </label>
      <input
        type="number"
        id="precio"
        step="0.01"
        placeholder="0.00"
        class="w-full text-sm sm:text-base border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        [formField]="$any(formData.precio)"
        [class.border-red-500]="formData.precio().invalid() && formData.precio().touched()"
      />
      @if (formData.precio().invalid() && formData.precio().touched()) {
        <div class="text-xs text-red-500 mt-1">
          {{ formData.precio().errors() | formErrorMessage }}
        </div>
      }
    </div>
    <!-- Cantidad -->
    <div class="flex-1">
      <label for="cantidad" class="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
        Cantidad
      </label>
      <input
        type="number"
        id="cantidad"
        step="1"
        placeholder="1"
        class="w-full text-sm sm:text-base border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        [formField]="$any(formData.cantidad)"
        [class.border-red-500]="formData.cantidad().invalid() && formData.cantidad().touched()"
      />
      @if (formData.cantidad().invalid() && formData.cantidad().touched()) {
        <div class="text-xs text-red-500 mt-1">
          {{ formData.cantidad().errors() | formErrorMessage }}
        </div>
      }
    </div>
  </div>
  <div class="pt-2">
    <app-button
      label="Agregar Producto"
      icon="bi bi-plus-lg"
      variant="primary"
      class="w-full py-2.5!"
      (onClick)="onAgregarProducto()"
    />
  </div>
</div>
